import React from "react";
import { Route } from "react-router-dom";
import PriceCard from "./Price";
import { PriceDeleteDialog } from "./price-dialog/PriceDeleteDialog";
import {  PriceUIProvider } from "./PriceUIContext";

export function PricePage({ history }) {
  
  const priceUIEvents = {
    newPriceButtonClick: () => {
      history.push(`/app/shopify-price/new`);
    },
    openEditPricePage: (id) => {
      history.push(`/app/shopify-price/${id}/edit`);
    },
    openDeletePriceDialog: (id) => {
      history.push(`/shopify-price/${id}/delete`);
    },
  };

  return (
    <PriceUIProvider priceUIEvents={priceUIEvents}>
      <Route exact path={`/shopify-price/:id/delete`}>
        {({ history, match }) => {
          return (
            <PriceDeleteDialog
              show={match != null}
              id={match && match.params.id}
              onHide={() => {
                history.push(`/shopify-price`);
              }}
            />
          );
        }}
      </Route>
      <PriceCard />
    </PriceUIProvider>
  );
}
